import React from 'react'

import { GuestCardForm } from './GuestCardForm'

/** Public guest card route. Schools come from the form payload (served schools only). */
export const GuestCardFormPage: React.FC = () => <GuestCardForm />
